export default __webpack_public_path__ + "static/media/fav.d7b126a4.svg";